'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$189() {
  this.c1O = null;
  this.c1M = null;
  this.c1N = false;
  this.c1K = null;
  this.c1L = false;
  this.c1P = false;
  this.c1Q = false;
  this.c1O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$$anon$189 as $c_Lpresto_types$$anon$189 };
$p = $c_Lpresto_types$$anon$189.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$189;
/** @constructor */
function $h_Lpresto_types$$anon$189() {
}
export { $h_Lpresto_types$$anon$189 as $h_Lpresto_types$$anon$189 };
$h_Lpresto_types$$anon$189.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.c1O;
});
$p.t = (function() {
  if ((!this.c1N)) {
    this.c1M = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c1N = true;
  }
  return this.c1M;
});
$p.ad = (function() {
  if ((!this.c1L)) {
    this.c1K = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rg, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rg, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c1L = true;
  }
  return this.c1K;
});
$p.v = (function() {
  if ((!this.c1Q)) {
    this.c1P = false;
    this.c1Q = true;
  }
  return this.c1P;
});
$p.aco = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
$p.ab = (function(a) {
  return this.aco(a);
});
var $d_Lpresto_types$$anon$189 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$189, "presto.types$$anon$189", ({
  Yv: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$189 as $d_Lpresto_types$$anon$189 };
//# sourceMappingURL=presto.types$$anon$189.js.map
